<button i18n="@@button-try-company-id" routerLink="/contact-us" class="button-primary mob:w-full tab:w-full">
    Try CompanyID
</button>

<a class="button-white-outline mob:w-full tab:w-full" i18n="@@button-plans-and-pricing" routerLink="/pricing">
    Plans and pricing
    <companyid-chevron color="white" position="right" />
</a>
